<template>
  <m-single-course-wrapper :course-link="courseLink">
    <template v-slot="{course}">
      <div class="container scroll-container mt-5">
        <div class="row">
          <div class="col-lg-8 col-md-12 col-sm-12  order-lg-1 order-md-1 order-sm-2 order-2">
            <div class="card shadow card-detail">
              <div class="card-body">
                <div class="title-row row">
                  <h1 class="title h4">{{ course.title }}</h1>
                </div>
                <hr/>
                <div class="row body-row">
                  <div class="col body-col">
                    <img
                        :src="course.thumbnail"
                        class="e-img"
                        :alt="course.title"
                    />
                    <p class="card-text" v-html="processContent(course.body)"/>
                    <div class="row">
                      <div class="col">
                        <h5 class="e-title" v-t="`course.single.lesson_group_title`"></h5>

                        <div v-if="course.lessons" class="accordion" id="lessonsGroup">
                          <div class="card" v-for="(lessons,section_name) in groupLessons(course.lessons)"
                               :key="lessons.id">

                            <div class="card-header">
                              <h2 class="btn border-0  btn-block text-decoration-none" type="button"
                                  data-toggle="collapse"
                                  :data-target="`#accordion-${removeSectionNameSpace(section_name)}`"
                                  aria-expanded="true"
                                  :aria-controls="`accordion-${removeSectionNameSpace(section_name)}`">
                                {{ section_name }}
                              </h2>
                            </div>

                            <div :id="`accordion-${removeSectionNameSpace(section_name)}`" class="collapse  "
                                 :class="{'show':(first_section === section_name)}"
                                 data-parent="#lessonsGroup">
                              <div class="card-body">

                                <div
                                    class="row text-center align-items-center bg-primary my-1 text-white py-2 rounded rounded-3"
                                    v-for="item in lessons" :key="item.id">

                                  <div class="col-6 my-2">{{ item.title }} ({{ isLessonFree(item.free) }})</div>
                                  <div class="col-6 my-2">
                                    <m-a class="text-white my-auto course-link shadow px-3 btn"
                                         :href="{name:'SingleLesson',params:{courseSlug:course.slug,slug:item.slug}}"
                                         v-t="`course.single.lesson_button`"></m-a>
                                  </div>

                                </div>

                              </div>
                            </div>

                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12 col-sm-12 order-lg-2 order-md-1 order-sm-1 order-1 card-info">
            <div class="card info-card bg-white shadow">
              <div class="card-body text-center">
                <div class="row info-row">
                  <div class="d-flex flex-column align-items-center col">
                    <m-icon icon="person"/>
                    <span class="title-2 text-center" v-t="`course.single.teacher`"></span>
                    <h6 v-if="course.author" class="font-weight-bolder text-center">
                      {{ `${course.author.name} ${course.author.last_name}` }}</h6>
                  </div>
                  <div class="d-flex flex-column align-items-center col">
                    <m-icon icon="book"/>
                    <span class="title-2" v-t="`course.single.lesson_count`"></span>
                    <h6 v-if="course.lessons" class="font-weight-bolder">{{ course.lessons.length }}</h6>
                  </div>
                </div>
                <div class="info-row row">
                  <hr class="info-hr"/>
                </div>
                <div class="info-row row">

                  <div v-t="`course.single.course_description`"
                       class="col d-flex flex-column align-items-center title-2"></div>

                  <div class="col d-flex flex-column align-items-center title-2">
                    <span v-if="course.course_status" v-html="course.course_status.description"/>
                  </div>

                </div>
                <div class="info-row row">
                  <div class="d-flex col flex-column align-items-center"
                  ><span class="title-2" v-t="`course.single.course_status`"></span></div
                  >
                  <div
                      class="d-flex col flex-column align-items-center"
                      v-if="course.course_status && course.course_status.course_status === 1"
                  ><span class="font-weight-bolder" v-t="`course.single.course_status_complete`"></span></div
                  >
                  <div class="col d-flex flex-column align-items-center" v-else
                  ><span class="font-weight-bolder" v-t="`course.single.course_status_progress`"></span></div
                  >
                </div>
                <div class="col d-flex flex-row justify-content-center info-row">
                  <button v-t="`course.single.buy_course`" class="btn-info rounded-pill btn mb-3 shadow">

                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row my-5" v-if="course.products">
          <div class="col-lg-12">
            <h3 class="text-center my-2" v-t="`course.single.related_products`"></h3>
          </div>
          <div class="col-lg-3" v-for="product in course.products">
            <m-product-card309 :product="product" :key="product.id"/>
          </div>
        </div>

      </div>


    </template>
  </m-single-course-wrapper>
</template>

<script>
import mSingleCourseWrapper from "../../Wrappers/SingleCourseWrapper";
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon'
import mProductCard309 from "../../Product/Card/C301";

export default {
  name: "SingleCourse1",
  components: {mSingleCourseWrapper, mA, mIcon, mProductCard309},
  props: {
    courseLink: {
      default: null
    },
    sortGroupOfLessonBaseOnTheyName: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      freeTranslation: ['غیررایگان', 'رایگان',],
      first_section: 0
    }
  },
  methods: {
    groupLessons(lessons) {
      let group = {};
      lessons.forEach((lesson) => {
        let section_name = lesson.section_name;
        if (Object.keys(group).indexOf(section_name) === -1) {

          if (Object.keys(group).length === 0) {
            this.first_section = section_name
          }

          group[section_name] = [lesson]
        } else {
          group[section_name].push(lesson)
        }
      })

      const sortedEntries = Object.entries(group).sort(([keyA], [keyB]) => {
        // Extract the numerical part of the key and compare
        const numA = parseInt(keyA.split(' ')[1]);
        const numB = parseInt(keyB.split(' ')[1]);
        return numA - numB;
      });
      console.log(this.sortGroupOfLessonBaseOnTheyName)
      if (this.sortGroupOfLessonBaseOnTheyName) {
        console.log('in')
        const sortedLessons = Object.fromEntries(sortedEntries);
        return sortedLessons
      }
      return group
    },
    removeSectionNameSpace(sectionName) {
      // if section name have space, accordion can find it and collapsed
      return sectionName.replace(/\s/g, '')

    },
    isLessonFree(value) {
      return value === 0 ? this.$t('lesson.general.lesson_un_free') : this.$t('lesson.general.lesson_free')
    }
  }
};
</script>

<style scoped>
.title {
  text-align: start;
  padding-right: 20px;
  padding-top: 50px;
}

hr {
  background-color: #fff;
  color: #cecece;
  width: 100%;
  display: flex;
  align-self: center;
}

.card-text {
  padding: 20px;
  text-align: right;
  font-size: 15px;
}

.e-title {
  margin-top: 20px;
}


.e-img {
  border-radius: 4px;
  width: 100%;
}

.order-btn :hover {
  background-color: var(--secondary);
}

.title-row {
  display: flex;
  align-items: baseline;
  align-self: center;
  padding: 0 20px 0;
}

.body-row {
  width: 100%;
  align-self: center;
  padding: 20px;
}

.body-col {
  padding: 0;
  margin: 0;
}

.info-hr {
  border: 0;
  border-bottom: 1px dashed;
  background: #999;
}

.info-row {
  padding: 15px 0 0;
}

.info-title {
  text-align: center;
  background-color: var(--primary);
  color: white;
  width: 130px;
  padding: 7px;
  border-radius: 4px;
}


.title-2 {
  font-size: 13px;
}


.scroll-container {
  scroll-behavior: smooth;
}


.course-link {
  border-radius: 50rem;
}

</style>